import * as React from 'react';
import { Button, PaletteColor, Typography, useTheme } from '@mui/material';
import { FaOptionIconProps } from '@europrocurement/l2d-icons';
import './L2DFSidebarAction.css';
import { Box } from '@mui/system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { KeycloakHasRole, KeycloakHasRoleProps } from '@europrocurement/l2d-keycloak';

export type L2DFSidebarActionProps = {
    label: string;
    icon: FaOptionIconProps;
    folded?: boolean;
    roles?: KeycloakHasRoleProps['kcRole'];
    color?: PaletteColor;
    onClick: () => void;
};

export const L2DFSidebarAction: React.FunctionComponent<L2DFSidebarActionProps> = function (props) {
    const theme = useTheme();
    const { label, icon, folded = false, color, onClick, roles } = props;
    const mainColor = color || theme.palette.primary;
    const textColor = theme.palette.background.paper;
    const classNames = ['l2df-sidebar-action'];

    if (folded) {
        classNames.push('l2df-sidebar-action-folded');
        icon.size = 'lg';
    }

    return (
        <KeycloakHasRole kcRole={roles}>
            <Button
                className={classNames.join(' ')}
                data-testid="l2df-sidebar-action"
                onClick={onClick}
                sx={{
                    backgroundColor: mainColor.main,
                    padding: folded ? '13px 24px 11px 24px ' : '16px 24px 16px 24px ',
                    color: textColor,
                    margin: folded ? '0 8px' : '0 20px',
                    verticalAlign: 'middle',
                    ':hover': { backgroundColor: mainColor.light },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        verticalAlign: 'middle',
                    }}
                >
                    {folded ? (
                        <FontAwesomeIcon
                            size="lg"
                            icon={icon.icon}
                        />
                    ) : (
                        <Typography
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                verticalAlign: 'middle',
                            }}
                        >
                            <FontAwesomeIcon
                                size="lg"
                                icon={icon.icon}
                            />
                            {label}
                        </Typography>
                    )}
                </Box>
            </Button>
        </KeycloakHasRole>
    );
};
